<template>
  <app-layout>
    <app-layout-header>
      <app-header :title="$route.meta.title" primary>
        <app-setting slot="right"></app-setting>
      </app-header>
    </app-layout-header>
    <app-layout-body>
      <div class="page-login-next">
        <div class="page-login-next__header">
          <h3 class="page-login-next__title">配置关键词</h3>
          <p class="page-login-next__tip">请认证完成公司主营业务的填写，云网客专业优化师会根据您的主营业务及网民关键词检索习惯为您配置关键词，并以此作为后续推广使用。</p>
        </div>
        <div class="page-login-next__body">
          <div class="page-login-next__step-nav">
            <el-steps :active="active" process-status="finish" align-center>
              <el-step title="填写主营业务" description="您的产品或服务是什么"></el-step>
              <el-step title="填写品牌及竞品名称" description="贵公司的品牌及竞品名称"></el-step>
              <el-step title="优化师配置关键词" description="优化师根据您的主营业务/品牌/竞品配置关键词，大约需2-3个工作日"></el-step>
              <el-step title="完成，开始智能投放" description="设置完成，启动智能投放"></el-step>
            </el-steps>
          </div>
          <div class="page-login-next__step-content">
            <app-step v-if="active === 0" title="填写主营业务" tip="贵公司为客户提供的产品或服务是什么">
              <template slot="body">
                <app-step-one ref="AppStepOne" :marketingCityList="form.marketingCityList" :mainBusinessList="form.mainBusinessList"></app-step-one>
              </template>
              <template slot="footer">
                <el-button type="primary" size="small" @click="next">设置完成，下一步</el-button>
                <el-button type="text" size="small" @click="jumpToHome">跳到首页</el-button>
              </template>
            </app-step>
            <app-step v-if="active === 1" title="填写品牌及竞品名称" tip="增加品牌曝光量，提升品牌知名度，抢夺竞争对手的客户资源">
              <template slot="body">
                <app-step-two ref="AppStepTwo" :brandNames="form.brandNames" :conpetitives="form.conpetitives"></app-step-two>
              </template>
              <template slot="footer">
                <el-button type="text" size="small" @click="previous">返回上一步</el-button>
                <el-button type="primary" size="small" @click="next">设置完成，下一步</el-button>
                <el-button type="text" size="small" @click="jumpToHome">跳到首页</el-button>
              </template>
            </app-step>
            <app-step v-if="active === 2" title="优化师配置关键词" tip="优化师正根据您所提供的主营业务/品牌/竞品及网民在各大搜索引擎的检索习惯配置符合您的关键词，此过程大约需2-3个工作日，请耐心等待；在此期间，您可以自定义装修您的官网，存数据，永久保存">
              <template slot="footer">
                <el-button type="text" size="small" @click="previous">返回上一步</el-button>
                <el-button type="primary" size="small" @click="jumpToSite">云官网装修</el-button>
                <el-button type="text" size="small" @click="jumpToHome">完成</el-button>
              </template>
            </app-step>
            <app-step v-if="active === 3" title="完成，开始智能投放" tip="优化师根据您所提供的主营业务/品牌/竞品及网民在各大搜索引擎的检索习惯共找出23945个符合您业务的关键词，接下来将进行智能推广">
              <template slot="footer">
                <el-button type="primary" size="small" @click="jumpToTopicList">开启智能推广</el-button>
                <el-button type="text" size="small" @click="jumpToHome">完成</el-button>
              </template>
            </app-step>
          </div>
        </div>
      </div>
    </app-layout-body>
    <app-layout-footer></app-layout-footer>
  </app-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSetting from '@/components/AppSetting'
import AppStep from './AppStep'
import AppStepOne from './AppStepOne'
import AppStepTwo from './AppStepTwo'

export default {
  name: 'LoginNext',
  components: {
    AppHeader,
    AppSetting,
    AppStep,
    AppStepOne,
    AppStepTwo
  },

  data () {
    return {
      active: 0
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    form () {
      return this.$store.state.globalConfig.config
    }
  },

  created () {
    this.initStep()
  },

  methods: {
    initStep () {
      const { configStatus } = this.user
      // const configStatus = 0

      // 0) 主营业务 1) 品牌及竞品 2) 待配词 3) 配置完成，等待开启智能推广 4) 推广中
      if (configStatus < 4) {
        this.active = configStatus
      } else {
        this.$router.push({ name: 'Home' })
      }
    },

    saveStepOne (data, cb) {
      this.$store.dispatch('setGlobalConfig', {
        params: { userId: this.user.id },
        body: {
          config: {
            ...this.form,
            ...data
          }
        }
      }).then(response => {
        this.setGlobalConfigStatus(this.active + 1, cb)
      })
    },

    saveStepTwo (data, cb) {
      this.$store.dispatch('setGlobalConfig', {
        params: { userId: this.user.id },
        body: {
          config: {
            ...this.form,
            ...data
          }
        }
      }).then(response => {
        this.setGlobalConfigStatus(this.active + 1, cb)
      })
    },

    setGlobalConfigStatus (configStatus, cb) {
      this.$store.dispatch('setGlobalConfigStatus', {
        params: { userId: this.user.id },
        body: { stage: configStatus }
      }).then(response => {
        cb && cb()
      })
    },

    next () {
      if (this.active === 0) {
        this.$refs.AppStepOne.$once('pass', (data) => {
          this.saveStepOne(data, () => {
            if (this.active++ > 3) this.active = 0
          })
        })
        this.$refs.AppStepOne.$emit('validate')
      } else if (this.active === 1) {
        this.$refs.AppStepTwo.$once('pass', (data) => {
          this.saveStepTwo(data, () => {
            if (this.active++ > 3) this.active = 0
          })
        })
        this.$refs.AppStepTwo.$emit('validate')
      } else {
        if (this.active++ > 3) this.active = 0
      }
    },

    previous () {
      if (this.active-- <= 0) this.active = 0
    },

    jumpToHome () {
      this.$router.push({ name: 'Home' })
    },

    jumpToSite () {
      this.$router.push({ name: 'Site' })
    },

    jumpToTopicList () {
      this.setGlobalConfigStatus(4, () => {
        this.$router.push({ name: 'ArticleList' })
      })
    }
  }
}
</script>

<style lang="scss">
.page-login-next {
  flex: 1;

  &__header {
    padding: $page-padding;
    background-color: #fff;
  }

  &__body {
    padding: $page-padding;
  }

  &__title {
    margin: 0;
  }

  &__tip {
    margin-top: 10px;
    margin-bottom: 0;
  }

  &__step-nav {
    padding: 15px;
    background-color: #fff;
  }

  &__step-content {
    margin-top: 15px;
    padding: 15px 15px 50px;
    background-color: #fff;
  }

  &__form {
    display: flex;

    &__left,
    &__right {
      flex: 1;
    }

    &__left {
      padding-right: 50px;
      border-right: 1px solid $border-color;
    }

    &__right {
      padding-left: 50px;
    }
  }
}
</style>
